module.exports = __webpack_public_path__ + "a76dfa0d18a0536af9e917cdb8f873b9.png";